module.exports = __webpack_public_path__ + "img/cat-black.4dd1fa46.svg";